import { type UseQueryResult, useQuery } from 'react-query';
import {
  PsuElectSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_RSUElect_LongShareDto,
} from '../../services/wealthlane-award-settlement-services';

const useGetParticipantPSULongShares = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  type: 'RSU' | 'Options' | 'PSU'
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_RSUElect_LongShareDto[] | undefined,
  unknown
> => {
  const participantLongShares = useQuery(
    ['getParticipantPSULongShares'],
    async () => {
      return await handleRequest(
        PsuElectSharedService.getApiAwardSettlementApiAppPSUElectLongSharesForParticipants()
      );
    },
    {
      enabled: type === 'PSU',
    }
  );

  return participantLongShares;
};

export default useGetParticipantPSULongShares;
